import { FeelGreatAPI } from 'Services/FeelGreat/APIs'

const { getFeelGreatProductsV3, getReferralCodes } = FeelGreatAPI

const feelGreateAPI = { getFeelGreatProductsV3, getReferralCodes }

export default feelGreateAPI
